import { Tag } from 'antd';
import { ArrowUpOutlined } from '@ant-design/icons';

const TOOLS = [
  {
    id: 'elsevier',
    publisher: 'Elsevier',
    name: 'Journal Finder',
    tipo: 'Buscador de revistas',
    tipoColor: '#52c41a',
    url: 'https://journalfinder.elsevier.com/',
    description: 'Introduce el abstract de tu manuscrito para encontrar la revista Elsevier más adecuada, con información sobre acceso abierto y cobertura APC.',
    accent: '#e84c22',
  },
  {
    id: 'wiley',
    publisher: 'Wiley',
    name: 'Journal Finder',
    tipo: 'Buscador de revistas',
    tipoColor: '#52c41a',
    url: 'https://www.wiley.com/en-es/journal-finder/',
    description: 'Encuentra revistas Wiley introduciendo el título o resumen del manuscrito. Muestra si el APC está cubierto a través del acuerdo institucional.',
    accent: '#003B5C',
  },
  {
    id: 'springer',
    publisher: 'Springer Nature',
    name: 'Journal and Funding Finder',
    tipo: 'Buscador de revistas',
    tipoColor: '#52c41a',
    url: 'https://link.springer.com/journals',
    description: 'Busca la revista Springer Nature por título, abstract o palabras clave. Detecta automáticamente la filiación institucional y muestra la cobertura del APC.',
    accent: '#cf0000',
  },
  {
    id: 'rsc',
    publisher: 'Royal Society of Chemistry',
    name: 'Journal Finder (ChronoHub)',
    tipo: 'Verificador de elegibilidad OA',
    tipoColor: '#1677ff',
    url: 'https://rsc.chronoshub.io/',
    description: 'Selecciona institución y financiador para comprobar las opciones de acceso abierto en cada revista RSC: cobertura de APC, descuentos o exenciones.',
    accent: '#0075b2',
  },
  {
    id: 'cambridge',
    publisher: 'Cambridge University Press',
    name: 'Eligibility Checker',
    tipo: 'Verificador de elegibilidad OA',
    tipoColor: '#1677ff',
    url: 'https://www.cambridge.org/core/eligibility-checker',
    description: 'Comprueba qué revistas de Cambridge University Press tienen el APC financiado para la Universidad de Oviedo.',
    accent: '#003080',
  },
  {
    id: 'acs',
    publisher: 'American Chemical Society',
    name: 'Acuerdo CRUE-CSIC',
    tipo: 'Acuerdo APC',
    tipoColor: '#fa8c16',
    url: 'https://acsopenscience.org/customers/crue-csic/',
    description: 'Lista de revistas ACS con APC cubierto al 100 % para autores de correspondencia de instituciones CRUE-CSIC, incluida la Universidad de Oviedo.',
    accent: '#3f51b5',
  },
  {
    id: 'ieee',
    publisher: 'IEEE',
    name: 'Acuerdo Open Access CRUE',
    tipo: 'Acuerdo APC',
    tipoColor: '#fa8c16',
    url: 'https://open.ieee.org/partners/crue-conferencia-de-rectores-de-las-universidades-espanolas/',
    description: 'Información sobre el acuerdo IEEE-CRUE: más de 180 revistas híbridas con APC cubierto y 20 % de descuento en revistas gold OA.',
    accent: '#00629B',
  },
  {
    id: 'inter-research',
    publisher: 'Inter-Research',
    name: 'Acuerdo con la Universidad de Oviedo',
    tipo: 'Acuerdo APC',
    tipoColor: '#fa8c16',
    url: 'https://www.int-res.com/for-authors/open-access-feewaivers',
    description: 'Información sobre el acuerdo transformativo de Inter-Research con la Universidad de Oviedo y lista de revistas elegibles para publicar en acceso abierto.',
    accent: '#1a7a6e',
  },
  {
    id: 'scoap3',
    publisher: 'SCOAP3 / CERN',
    name: 'Revistas 2025-2027',
    tipo: 'Lista de revistas (sin APC)',
    tipoColor: '#8c8c8c',
    url: 'https://scoap3.org/journals-2025-2027/',
    description: 'Lista de revistas de física de altas energías del consorcio SCOAP3. Los autores publican en acceso abierto sin ningún coste individual.',
    accent: '#e00000',
  },
];

const JournalFindersComponent = () => (
  <div style={{ textAlign: 'left' }}>

    {/* Header */}
    <div style={{ paddingTop: 28, paddingBottom: 4, textAlign: 'center', background: '#fafafa' }}>
      <div style={{
        fontSize: 22, fontWeight: 700, color: '#1a1a1a',
        letterSpacing: -0.3, lineHeight: 1.3,
        fontFamily: "'Inter','Segoe UI',sans-serif",
        padding: '0 24px',
      }}>
        Journal Finders y herramientas de elegibilidad OA
      </div>
      <div style={{ fontSize: 13, color: '#888', marginTop: 6, paddingBottom: 20 }}>
        Herramientas de editores para seleccionar revista y verificar financiación de APC según filiación institucional
      </div>
    </div>

    {/* Grid de cards */}
    <div style={{
      padding: '24px 48px 48px',
      maxWidth: 1280,
      margin: '0 auto',
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))',
      gap: 24,
    }}>
      {TOOLS.map(t => (
        <a
          key={t.id}
          href={t.url}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none', color: 'inherit' }}
        >
          <div style={{
            background: '#fff',
            border: '1px solid #e8e8e8',
            borderRadius: 10,
            overflow: 'hidden',
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
            transition: 'box-shadow 0.2s, transform 0.15s',
            cursor: 'pointer',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
          }}
          onMouseEnter={e => {
            e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.13)';
            e.currentTarget.style.transform = 'translateY(-2px)';
          }}
          onMouseLeave={e => {
            e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.06)';
            e.currentTarget.style.transform = 'translateY(0)';
          }}
          >
            {/* Franja de color superior */}
            <div style={{ height: 5, background: t.accent }} />

            {/* Contenido */}
            <div style={{ padding: '20px 24px 24px', flex: 1, display: 'flex', flexDirection: 'column' }}>

              {/* Publisher + tipo */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 }}>
                <span style={{ fontSize: 11, fontWeight: 700, color: '#aaa', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
                  {t.publisher}
                </span>
                <Tag style={{
                  borderRadius: 4,
                  fontSize: 10,
                  fontWeight: 600,
                  padding: '1px 7px',
                  border: 'none',
                  background: t.tipoColor + '18',
                  color: t.tipoColor,
                  marginLeft: 8,
                  whiteSpace: 'nowrap',
                  flexShrink: 0,
                }}>
                  {t.tipo}
                </Tag>
              </div>

              {/* Título */}
              <div style={{
                fontSize: 17, fontWeight: 700, color: '#1a1a1a',
                marginBottom: 12, lineHeight: 1.3,
                fontFamily: "'Inter','Segoe UI',sans-serif",
                display: 'flex', alignItems: 'center', gap: 6,
              }}>
                {t.name}
                <ArrowUpOutlined style={{ fontSize: 12, color: '#aaa', transform: 'rotate(45deg)', flexShrink: 0 }} />
              </div>

              {/* Descripción */}
              <p style={{
                fontSize: 13.5, color: '#555', lineHeight: 1.65,
                margin: 0, flex: 1,
              }}>
                {t.description}
              </p>
            </div>
          </div>
        </a>
      ))}
    </div>
  </div>
);

export default JournalFindersComponent;
